var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('region-choice-section',{staticClass:"region-choice-section-module",attrs:{"title":_vm.attributes.regionChoice_title,"intro":_vm.attributes.regionChoice_intro,"regions":_vm.mappedRegions}})}
var staticRenderFns = []

export { render, staticRenderFns }